/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ remaining: NonNullable<unknown>, limit: NonNullable<unknown> }} Directory_Submit_Quota_RemainingInputs */

const en_directory_submit_quota_remaining = /** @type {(inputs: Directory_Submit_Quota_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.remaining} of ${i?.limit} free submissions remaining.`)
};

const zh_directory_submit_quota_remaining = /** @type {(inputs: Directory_Submit_Quota_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`免费额度剩余 ${i?.remaining}/${i?.limit} 次。`)
};

/**
* | output |
* | --- |
* | "{remaining} of {limit} free submissions remaining." |
*
* @param {Directory_Submit_Quota_RemainingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_quota_remaining = /** @type {((inputs: Directory_Submit_Quota_RemainingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Quota_RemainingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_quota_remaining(inputs)
	return zh_directory_submit_quota_remaining(inputs)
});
export { directory_submit_quota_remaining as "directory.submit.quota_remaining" }